<msf-list-page-wrapper  [leftSize]="'12'" [rightSize]="'0'">

  <div left #left>
    <div class="page-header">
      <div class="header-title">
        <h3 class="m-0">{{ subtitle | translate }}</h3>
        <ng-content select="[header-content]"></ng-content>
      </div>
      <div class="header-actions">
        <ng-content select="[controller]"></ng-content>
      </div>
    </div>
    <app-dynamic-data-table
      [(loading)]="isLoading"
      [service]="service"
      [getAllMethod]="getAllMethod"
      [getTotalMethod]="getTotalMethod"
      [filter]="filtersParams"
      [toggleFilter]="toggleFilter"
      [storageKey]="storageKey"
      [columns]="columns"
      [defaultParams]="defaultParams"
      [methodWithParams]="methodWithParams"
      (currentPageData)="currentPageData.emit($event)"
      (onRowClick)="onRowClick.emit($event)"
    ></app-dynamic-data-table>

  </div>

</msf-list-page-wrapper>
